import React from "react";
import { LanguageLabel } from "../AddLanguageWizard.styled";

const TargetLanguageLabel = ({ language }) => (
  <LanguageLabel>
    Target language: {language?.name} ({language?.shortName})
  </LanguageLabel>
);

export default TargetLanguageLabel;
